import $ from 'jquery';
import axios from 'axios';
import Alert from '../common/alerts/alert';

/**
 * Contact form plugin
 */
export default class ContactForm {
    /**
     * @param $form Contact form
     * @param options Additional options
     */
    constructor($form, options = {}) {
        this.options = $.extend(true, {
            classes: {
                alert: {
                    success: 'contact-form__alert--success',
                    error: 'contact-form__alert--error',
                },
                agreement: {
                    stateOpened: 'agreement__text--opened',
                    content: 'agreement__text',
                    trigger: 'agreement__trigger',
                },
                inputError: 'input--error',
                submitButton: 'btn-submit',
                required: 'contact-form__required-info',
            },
        }, options);

        if (!$form) {
            return;
        }

        this.$form = $form;
        this.$inputs = this.$form.querySelectorAll('input, textarea');
        this.$submitButton = this.$form.querySelector('.' + this.options.classes.submitButton);
        this.$agreements = this.$form.querySelectorAll('.agreement__item');
        this.$required = this.$form.querySelector('.' + this.options.classes.required);

        this.$csrf = this.$form.querySelector('[name=csrfmiddlewaretoken]');

        this.init();
    }

    init() {
        this.initValidation();
        this.initAgreements();
        this.initCSRF();
    }

    initValidation() {
        this.submitHandleToggle(this.$form);
    }

    initAgreements() {
        this.agreementHandleToggle();
    }

    initCSRF() {
        if(this.$csrf) {
            let value = this.$csrf.value;
            this.setCookie('csrftoken', value, 3);
        }
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    validateForm(response) {
        this.$form.querySelectorAll(".contact-form__error").forEach(e => e.remove());
        this.$form.querySelectorAll("." + this.options.classes.inputError).forEach(e => e.classList.remove(this.options.classes.inputError));
        
        if (response.data.errors) {
            this.$required.classList.remove(this.options.classes.required + '--hidden')
            
            if(document.querySelector('.alert')) document.querySelector('.alert').remove();

            new Alert({
                type: 'error',
                header: 'Błąd',
                message: response.data.message,
            });

            Object.keys(response.data.errors).forEach((key) => {
                var errorText = document.createElement("div");
                errorText.classList.add("contact-form__error");
                errorText.append(`${response.data.errors[key]}`);

                var input = this.$form.querySelector(`#id_${key}`);
                input.classList.add(this.options.classes.inputError);
                input.parentElement.append(errorText);
            });
        } else {
            new Alert({
                type: 'success',
                header: 'Dziękujemy!',
                message: response.data.message,
            });

            this.$form.reset();
            this.$required.classList.add(this.options.classes.required + '--hidden')
        }
    }

    submitForm($form, $this) {
        axios.post($form.getAttribute('action'), new FormData($form))
            .then(function (response) {
                $this.validateForm(response);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    submitHandleToggle($form) {

        const handler = (e) => {
            e.preventDefault();
            this.submitForm($form, this);
        }

        this.$submitButton.addEventListener('click', handler);
    }

    agreementHandleToggle() {

        const handler = (e, $a) => {
            e.preventDefault();
            $a.querySelector('.' + this.options.classes.agreement.content).classList.toggle(this.options.classes.agreement.stateOpened);
        }

        this.$agreements.forEach(($agreement) => $agreement.querySelector('a').addEventListener('click', (e) => handler(e, $agreement)));
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/contact-form.js